<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Borderôs</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Borderôs</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Data</th>
                    <th scope="col" class="border-0">Nº operação</th>
                    <th scope="col" class="border-0">Preço total da cessão</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(
                      advancePaymentOperation, index
                    ) in advancePaymentOperations"
                    :key="index"
                  >
                    <td></td>
                    <td>{{ advancePaymentOperation.OperationDate | date }}</td>
                    <td>{{ advancePaymentOperation.OperationNumber }}</td>
                    <td>{{ advancePaymentOperation.AmountNet | currency }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="
                              $isAuthorize('AdvancePaymentOperation', 'Get')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenAdvancePaymentOperation($event, index, true)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>

                          <a
                            v-if="
                              $isAuthorize('AdvancePaymentOperation', 'Update')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenAdvancePaymentOperation($event, index)
                            "
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="
                              $isAuthorize('AdvancePaymentOperation', 'Get')
                            "
                            class="dropdown-item"
                            href="#"
                            :class="loadingDownload ? 'disabled' : ''"
                            v-on:click.stop="
                              GetAdvancePaymentOperation(
                                advancePaymentOperation.Id,
                                true
                              )
                            "
                          >
                            <template v-if="loadingDownload">
                              <loader
                                :small="true"
                                :isLoading="loadingDownload"
                              ></loader>
                            </template>
                            <template v-else>
                              <i class="fas fa-long-arrow-alt-down mr-2"></i>
                              Download
                            </template>
                          </a>
                          <a
                            v-if="
                              $isAuthorize('AdvancePaymentOperation', 'Delete')
                            "
                            class="dropdown-item mt-1"
                            href="#"
                            v-on:click="
                              ConfirmDeleteAdvancePaymentOperation(
                                $event,
                                index
                              )
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      advancePaymentOperations == undefined ||
                      advancePaymentOperations == null ||
                      advancePaymentOperations.length == 0
                    "
                  >
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormAdvancePaymentOperation"
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>
      <div v-if="!loadingModal">
        <!-- Steps -->
        <nav class="nav-steps" aria-label="breadcrumb">
          <ol
            style="background-color: #fff; padding: 0.75rem 0rem"
            class="breadcrumb"
          >
            <li class="breadcrumb-item">
              <a
                class="black-text"
                href="#"
                v-on:click="GoToStep($event, 0)"
                :class="[mCurrentStep == 0 ? 'active' : '']"
                >Detalhes</a
              >
            </li>

            <li class="breadcrumb-item">
              <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
              <a
                class="black-text"
                href="#"
                v-on:click="GoToStep($event, 1)"
                :class="[mCurrentStep == 1 ? 'active' : '']"
                >Antecipações</a
              >
            </li>
          </ol>
        </nav>
        <!-- Step 0 -->
        <div v-if="mCurrentStep === 0">
          <div>
            <ValidationObserver
              tag="form"
              ref="AdvancePaymentOperationValidationForm"
            >
              <d-form-row>
                <!-- OperationDate -->
                <d-col md="6" class="form-group">
                  <label>Data</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, invalid }"
                  >
                    <date-field
                      v-model="infoAdvancePaymentOperation.OperationDate"
                      v-bind:inputClass="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
                <!-- OperationNumber -->
                <d-col md="6" class="form-group">
                  <label>Nº operação de cessão</label>
                  <ValidationProvider
                    rules="required|min:1"
                    v-slot="{ errors, invalid }"
                  >
                    <d-form-input
                      type="number"
                      :class="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      v-model="infoAdvancePaymentOperation.OperationNumber"
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <!-- BankAgency -->
              <d-form-row>
                <d-col md="12" class="form-group">
                  <label>Conta bancária</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, invalid }"
                  >
                    <d-select
                      :class="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      v-model="infoAdvancePaymentOperation.BankAccount.Code"
                      :disabled="isSeeing || disabledCreating"
                    >
                      <option :value="null" selected>Selecione</option>
                      <option
                        v-for="type in bankAccounts"
                        v-bind:key="type.Code"
                        v-bind:value="type.Code"
                      >
                        {{
                          type.Bank.Name +
                          " -  Agência: " +
                          type.BankAgency +
                          " Conta: " +
                          type.BankAccount
                        }}
                      </option>
                    </d-select>
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdditionalForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <d-form-row>
                <!-- Amount -->
                <d-col md="6" class="form-group">
                  <label>Valor total de créditos</label>
                  <ValidationProvider
                    rules="required|min_value:0.01"
                    v-slot="{ errors, invalid }"
                  >
                    <currency-input
                      class="form-control"
                      :class="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      v-model="infoAdvancePaymentOperation.Amount"
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
                <!-- MonthlyTax -->
                <d-col md="3" class="form-group">
                  <label>Taxa mensal da cessão</label>
                  <ValidationProvider
                    rules="required|min_value:0.01"
                    v-slot="{ errors, invalid }"
                  >
                    <decimal-field
                      class="form-control"
                      :class="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      v-model="infoAdvancePaymentOperation.MonthlyTax"
                      type="percentage" 
                      :maxDecimalPlaces="5"
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
                <!-- AnnualTax -->
                <d-col md="3" class="form-group">
                  <label>Taxa anual da cessão</label>
                  <ValidationProvider
                    rules="required|min_value:0.01"
                    v-slot="{ errors, invalid }"
                  >
                    <decimal-field
                      class="form-control"
                      :class="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      v-model="infoAdvancePaymentOperation.AnnualTax"
                      type="percentage"
                      :maxDecimalPlaces="5"
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <d-form-row>
                <!-- IOFAmount -->
                <d-col md="3" class="form-group">
                  <label>Valor do IOF</label>
                  <ValidationProvider
                    rules="required|min_value:0.01"
                    v-slot="{ errors, invalid }"
                  >
                    <currency-input
                      class="form-control"
                      :class="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      v-model="infoAdvancePaymentOperation.IOFAmount"
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
                <!-- TariffAmount -->
                <d-col md="3" class="form-group">
                  <label>Tarifa de contratação</label>
                  <ValidationProvider
                    rules="required|min_value:0.01"
                    v-slot="{ errors, invalid }"
                  >
                    <currency-input
                      class="form-control"
                      :class="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      v-model="infoAdvancePaymentOperation.TariffAmount"
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
                <!-- AmountNet -->
                <d-col md="6" class="form-group">
                  <label>Preço total da cessão</label>
                  <ValidationProvider
                    rules="required|min_value:0.01"
                    v-slot="{ errors, invalid }"
                  >
                    <currency-input
                      class="form-control"
                      :class="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      v-model="infoAdvancePaymentOperation.AmountNet"
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <!-- Url -->
              <d-form-row v-if="isCreating">
                <d-col md="12" class="form-group">
                  <label>Arquivo</label>
                  <ValidationProvider vid="file" v-slot="{ errors, invalid }">
                    <b-form-file
                      type="file"
                      :inputClass="
                        validatedAdvancePaymentOperationForm
                          | showValidateError(invalid)
                      "
                      placeholder="Selecione ou arraste um arquivo"
                      drop-placeholder="Solte o arquivo aqui"
                      browse-text="Selecionar"
                      accept="application/pdf"
                      @change="SelectFile($event, true)"
                      @input="SelectFile($event, false)"
                      :disabled="isSeeing || disabledCreating"
                    />
                    <div
                      class="invalid-feedback d-block"
                      v-if="validatedAdvancePaymentOperationForm"
                    >
                      {{ errors[0] }}
                    </div>
                  </ValidationProvider>
                </d-col>
              </d-form-row>
              <d-form-row>
                <d-col md="12" class="form-group">
                  <label>Descrição</label>
                  <b-form-textarea
                    type="text"
                    rows="4"
                    v-model="infoAdvancePaymentOperation.Description"
                    :disabled="isSeeing || disabledCreating"
                  />
                </d-col>
              </d-form-row>
            </ValidationObserver>
          </div>
        </div>
        <!-- Step 1 -->
        <div v-if="mCurrentStep === 1">
          <!-- Table -->
          <d-form-row>
            <b-col>
              <b-button
                v-if="
                  !isSeeing &&
                  $isAuthorize('AdvancePaymentOperationAdditional', 'Add')
                "
                class="float-right"
                variant="success"
                size="sm"
                v-on:click="OpenAdditional(true)"
                >Nova antecipação</b-button
              >
            </b-col>
          </d-form-row>
          <d-form-row>
            <table class="table mt-2 mb-0">
              <thead class="bg-s2p-gray-light">
                <tr>
                  <th scope="col" class="border-0 text-center">
                    Data de vencimento
                  </th>
                  <th scope="col" class="border-0 text-center">Valor (R$)</th>
                  <th scope="col" class="border-0 text-center">Bandeira</th>
                  <th scope="col" class="border-0 text-center">
                    Credenciadora
                  </th>
                  <th v-if="!isSeeing" scope="col" class="border-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    additional, index
                  ) in infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals"
                  :key="'taxIdx' + index"
                >
                  <td class="text-center">{{ additional.DueDate | date }}</td>
                  <td class="text-center">
                    {{ additional.Amount | currency }}
                  </td>
                  <td class="text-center">{{ additional.Brand.Name }}</td>
                  <td class="text-center">{{ additional.Gateway.Name }}</td>
                  <td v-if="!isSeeing">
                    <div class="dropdown">
                      <button
                        class="btn btn-outline-secondary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Opções
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          v-if="
                            $isAuthorize('AdvancePaymentOperation', 'Update')
                          "
                          class="dropdown-item"
                          href="#"
                          v-on:click="OpenAdditional(false, index)"
                        >
                          <i class="fas fa-highlighter mr-2"></i> Editar
                        </a>

                        <a
                          class="dropdown-item mt-1"
                          href="#"
                          v-on:click="
                            ConfirmDeleteAdvancePaymentOperationAdditionals(
                              $event,
                              index
                            )
                          "
                        >
                          <i class="fas fa-trash-alt mr-2"></i> Remover
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr
                  v-if="
                    infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals ==
                      undefined ||
                    infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals ==
                      null ||
                    infoAdvancePaymentOperation
                      .AdvancePaymentOperationAdditionals.length == 0
                  "
                >
                  <td class="text-center" colspan="5">Sem registros</td>
                </tr>
              </tbody>
            </table>
          </d-form-row>
        </div>
      </div>

      <template slot="modal-footer">
        <b-button-group>
          <b-button
            size="sm"
            class="btn btn-secondary"
            @click="BackStep()"
            :disabled="mCurrentStep === 0 || loadingAddUpdateAdditional"
          >
            <i class="fas fa-arrow-left"></i>
          </b-button>
          <b-button
            size="sm"
            class="btn btn-secondary"
            @click="ProcessNextStep()"
            :disabled="mCurrentStep == 1 && isSeeing"
            v-if="mCurrentStep !== 1"
          >
            <i class="fas fa-arrow-right"></i>
          </b-button>
          <b-button
            type="button"
            class="btn btn-success"
            :disabled="
              loadingAddUpdateAdditional ||
              isSeeing ||
              infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals ==
                undefined ||
              infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals ==
                null ||
              infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals
                .length == 0
            "
            v-on:click="CreateOrUpdate()"
            v-if="mCurrentStep === 1 && !isSeeing"
          >
            <template v-if="!loadingAddUpdateAdditional">{{
              pOpened != null ? " Salvar alterações" : " Cadastrar borderô"
            }}</template>
            <template v-else>
              <loader
                :small="true"
                :isLoading="loadingAddUpdateAdditional"
              ></loader>
            </template>
          </b-button>
        </b-button-group>
      </template>
    </b-modal>

    <b-modal
      size="sm"
      id="mFormAdditional"
      :title="modalTitleAdditional"
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModalAdditional">
        <loader :is-loading="loadingModalAdditional"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="AdditionalValidationForm">
          <d-form-row>
            <!-- DueDate -->
            <d-col md="12" class="form-group">
              <label>Data de vencimento</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <date-field
                  v-model="infoAdditional.DueDate"
                  v-bind:inputClass="
                    validatedAdditionalForm | showValidateError(invalid)
                  "
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAdditionalForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Amount -->
            <d-col md="12" class="form-group">
              <label>Valor</label>
              <ValidationProvider
                rules="required|min_value:0.01"
                v-slot="{ errors, invalid }"
              >
                <currency-input
                  class="form-control"
                  :class="validatedAdditionalForm | showValidateError(invalid)"
                  v-model="infoAdditional.Amount"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAdditionalForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Brand -->
            <d-col md="12" class="form-group">
              <label>Bandeira</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedAdditionalForm | showValidateError(invalid)"
                  v-model="infoAdditional.Brand.Code"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in brands"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAdditionalForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Gateway -->
            <d-col md="12" class="form-group">
              <label>Credenciadora</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedAdditionalForm | showValidateError(invalid)"
                  v-model="infoAdditional.Gateway.Code"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="type in gateways"
                    v-bind:key="type.Code"
                    v-bind:value="type.Code"
                  >
                    {{ type.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedAdditionalForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer">
        <!-- Emulate built in modal footer ok and cancel button actions -->

        <b-button
          size="sm"
          variant="success"
          @click="SaveAdditional()"
          :disabled="loadingAddUpdateAdditional || loadingModalAdditional"
        >
          <template v-if="!loadingAddUpdateAdditional">
            {{ pOpenedAdditionals != null ? " Alterar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader
              :small="true"
              :isLoading="loadingAddUpdateAdditional"
            ></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            placeholder="Nº operação"
            type="text"
            class="form-control"
            v-model="filter.OperationNumber"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Data inicial</label>
          <date-field v-model="filter.OperationDateInitial" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>Data final</label>
          <date-field v-model="filter.OperationDateEnd" />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('AdvancePaymentOperation', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo borderô"
      v-on:click="OpenAdvancePaymentOperation($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { AppendFormData } from "../../utils/fileUtils.js";
import { hasValue } from "../../utils/functions.js";
import decimalField from "../common/decimal-field.vue";
import dateField from "../common/date-field";
export default {
  name: "advance-payment-operations",
  components: {
    dateField,
    decimalField,
  },
  data: function () {
    return {
      countFilter: 0,
      pOpened: null,
      pOpenedAdditionals: null,
      filter: {
        OperationNumber: null,
        OperationDateInitial: null,
        OperationDateEnd: null,
      },
      infoAdvancePaymentOperation: {
        OperationDate: null,
        OperationNumber: null,
        BankAccount: { Code: null },
        Amount: null,
        MonthlyTax: null,
        AnnualTax: null,
        IOFAmount: null,
        TariffAmount: null,
        AmountNet: null,
        Url: null,
        Description: null,
        AdvancePaymentOperationAdditionals: [],
      },
      infoAdditional: {
        IdAdvancePaymentOperation: null,
        DueDate: null,
        Amount: null,
        Brand: {
          Code: null,
          Name: null,
        },
        Gateway: {
          Code: null,
          Name: null,
        },
      },
      idAdvancePaymentOperation: 0,
      idAdditional: 0,
      isSeeing: false,
      isCreating: false,
      isCreatingAdditional: false,
      disabledCreating: false,
      loadingAddUpdate: false,
      loadingAddUpdateAdditional: false,
      loadingList: false,
      loadingModal: false,
      loadingModalAdditional: false,
      loadingDownload: false,
      loadingReport: false,
      validatedAdvancePaymentOperationForm: false,
      validatedAdditionalForm: false,
      mCurrentStep: 0,
      modalTitle: "Novo borderô",
      modalTitleAdditional: "Nova antecipação",
      advancePaymentOperationFile: null,
      advancePaymentOperations: [],
      brands: [],
      gateways: [],
      bankAccounts: [],
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalAmount: 0,
        TotalItems: 0,
      },
      mSteps: [
        "details", //0
        "advancement", //1
      ],
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListAdvancePaymentOperation();
    },
    "pagination.RowsPerPage": function () {
      this.ListAdvancePaymentOperation();
    },
  },
  mounted() {
    this.ListAdvancePaymentOperation();
    this.ListBrand();
    this.ListGateway();
    this.ListBankAccounts();
  },
  methods: {
    GoToStep: function (e, stepToGo) {
      e.preventDefault();
      if (stepToGo < this.mSteps.length && stepToGo >= 0) {
        if (stepToGo < this.mCurrentStep) {
          this.mCurrentStep = stepToGo;
        } else {
          this.ProcessNextStep(stepToGo);
        }
      }
    },
    NextStep: function () {
      if (this.mCurrentStep < this.mSteps.length - 1) {
        this.mCurrentStep += 1;
      }
    },
    BackStep: function () {
      if (this.mCurrentStep >= 1) {
        this.mCurrentStep -= 1;
      }
    },
    ProcessNextStep: function (nextStep = null) {
      if (this.isSeeing) {
        if (nextStep != null) this.mCurrentStep = nextStep;
        else this.NextStep();
        return;
      }
      switch (this.mCurrentStep) {
        case 0: // Detalhe
          this.validatedAdvancePaymentOperationForm = true;
          this.CheckValidityStep("AdvancePaymentOperationValidationForm");
          break;

        default:
          if (nextStep != null) {
            this.mCurrentStep = nextStep;
          } else {
            this.NextStep();
          }
          break;
      }
    },
    CheckValidityStep(step, nextStep) {
      if (step) {
        this.$refs[step].validate().then((isValid) => {
          if (isValid && nextStep == null) {
            this.NextStep();
          }
        });
      }
    },
    CreateOrUpdate: function () {
      if (this.isCreating) {
        // Add
        if (
          this.advancePaymentOperationFile == null ||
          this.advancePaymentOperationFile == undefined
        ) {
          this.$refs.AdvancePaymentOperationValidationForm.setErrors({
            file: ["O campo é obrigatório"],
          });
          this.loadingAddUpdate = false;
          this.isSeeing = false;
          return;
        }

        let advancePaymentOperation = this.infoAdvancePaymentOperation;
        advancePaymentOperation = JSON.parse(
          JSON.stringify(advancePaymentOperation)
        );
        delete advancePaymentOperation.Url;
        var formData = this.GetFormData(advancePaymentOperation);
        formData.append(
          "File",
          this.advancePaymentOperationFile,
          this.advancePaymentOperationFile.name
        );

        this.$store
          .dispatch("AddAdvancePaymentOperation", formData)
          .then((response) => {
            this.$makeToast(
              "O borderô foi cadastrado corretamente na base de dados",
              "success",
              "Borderô"
            );

            this.idAdvancePaymentOperation = response.Id;
            this.ListAdvancePaymentOperation();
            this.$bvModal.hide("mFormAdvancePaymentOperation");
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao criar o borderô",
              error
            );
          })
          .finally(() => {
            this.loadingAddUpdate = false;
            this.isSeeing = false;
          });
      } else {
        // Update
        this.$store
          .dispatch(
            "UpdateAdvancePaymentOperation",
            this.infoAdvancePaymentOperation
          )
          .then(() => {
            this.$makeToast(
              "Suas modificações foram salvas na base de dados",
              "success",
              "Borderô"
            );
            this.ListAdvancePaymentOperation();
            this.$bvModal.hide("mFormAdvancePaymentOperation");
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao atualizar o borderô",
              error
            );
          })
          .finally(() => {
            this.loadingAddUpdate = false;
            this.isSeeing = false;
          });
      }
    },
    ListBrand: function () {
      this.$store
        .dispatch("ListBrand", {})
        .then((response) => {
          this.brands = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página.",
            "danger",
            "Erro ao listar as bandeiras",
            error
          );
        });
    },
    ListGateway: function () {
      this.$store
        .dispatch("ListGateway", {})
        .then((response) => {
          this.gateways = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página.",
            "danger",
            "Erro ao listar as credenciadoras",
            error
          );
        });
    },
    ListBankAccounts: function () {
      this.$store
        .dispatch("ListBankAccountsS2P", {})
        .then((response) => {
          this.bankAccounts = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página.",
            "danger",
            "Erro ao listar as credenciadoras",
            error
          );
        });
    },
    SelectFile(obj, isEvent) {
      let file = null;
      if (isEvent) file = obj.target.files[0];
      else file = obj;
      if (file == null) return;

      if (file.type == "application/pdf") {
        this.advancePaymentOperationFile = file;
        this.$refs.AdvancePaymentOperationValidationForm.reset();
      } else {
        this.$makeToast(
          "O arquivo selecionado não é um PDF válido",
          "danger",
          "Borderô"
        );
      }
    },
    GetFormData(object) {
      return AppendFormData(object);
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListAdvancePaymentOperation();
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.OperationNumber": this.filter.OperationNumber,
        OperationDateInitial: this.filter.OperationDateInitial,
        OperationDateEnd: this.filter.OperationDateEnd,
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(false);
      this.$store
        .dispatch("ReportAdvancePaymentOperation", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    OpenAdvancePaymentOperation: function (e, i, view) {
      e.preventDefault();
      this.validatedAdvancePaymentOperationForm = false;
      this.loadingAddUpdate = false;
      this.disabledCreating = false;
      this.mCurrentStep = 0;
      this.ResetInfoAdvancePaymentOperation();

      if (view == undefined && i != undefined) {
        // Edit
        this.isCreating = false;
        this.idAdvancePaymentOperation = this.advancePaymentOperations[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar borderô";
        this.GetAdvancePaymentOperation(this.idAdvancePaymentOperation);
      } else if (view == undefined && i == undefined) {
        // Add new
        this.isCreating = true;
        this.isSeeing = false;
        this.modalTitle = "Novo borderô";
      } else {
        // View
        this.isCreating = false;
        this.idAdvancePaymentOperation = this.advancePaymentOperations[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do borderô";
        this.GetAdvancePaymentOperation(this.idAdvancePaymentOperation);
      }
      this.$bvModal.show("mFormAdvancePaymentOperation");
    },
    ResetInfoAdvancePaymentOperation: function () {
      this.infoAdvancePaymentOperation = {
        OperationDate: null,
        OperationNumber: null,
        BankAccount: { Code: null },
        Amount: null,
        MonthlyTax: null,
        AnnualTax: null,
        IOFAmount: null,
        TariffAmount: null,
        AmountNet: null,
        Url: null,
        Description: null,
        AdvancePaymentOperationAdditionals: [],
      };
    },
    BackStep: function () {
      if (this.mCurrentStep == 1 && this.isCreating)
        this.disabledCreating = true;

      this.mCurrentStep = 0;
    },
    CheckValidity: function () {
      this.validatedAdvancePaymentOperationForm = true;
      this.$refs.AdvancePaymentOperationValidationForm.validate().then(
        (isValid) => {
          if (isValid) {
            if (this.isCreating) {
              if (
                this.advancePaymentOperationFile == null ||
                this.advancePaymentOperationFile == undefined
              ) {
                this.$refs.AdvancePaymentOperationValidationForm.setErrors({
                  file: ["O campo é obrigatório"],
                });
                return;
              }

              this.$makeToast(
                "Para continuar, é necessário adicionar o borderô.",
                "warning",
                "Atenção"
              );
            } else this.mCurrentStep = 1;
          }
        }
      );
    },
    GetAdvancePaymentOperation: function (id, download = false) {
      if (id != 0) {
        if (download) this.loadingDownload = true;
        else this.loadingModal = true;
        this.$store
          .dispatch("GetAdvancePaymentOperation", {
            id: id,
          })
          .then((response) => {
            this.infoAdvancePaymentOperation = response;

            if (download && hasValue(response.Url)) {
              this.$makeToast(
                "Aguarde a conclusão do download",
                "info",
                "Borderô"
              );
              window.open(response.Url, "_self");
            }
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar o borderô",
              error
            );
          })
          .finally(() => {
            if (download) this.loadingDownload = false;
            else this.loadingModal = false;
          });
      }
    },
    ListAdvancePaymentOperation: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.OperationNumber)) this.countFilter++;
      if (
        hasValue(this.filter.OperationDateInitial) ||
        hasValue(this.filter.OperationDateEnd)
      )
        this.countFilter++;
      this.loadingList = true;
      let data = this.GetParamsData();
      delete data.TotalItems;
      this.$store
        .dispatch("ListAdvancePaymentOperation", { params: data })
        .then((response) => {
          this.advancePaymentOperations = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os borderôs",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        OperationNumber: null,
        OperationDateInitial: null,
        OperationDateEnd: null,
      };
      this.ListAdvancePaymentOperation();
    },
    ConfirmDeleteAdvancePaymentOperation: function (e, i) {
      e.preventDefault();
      let deleted = this.advancePaymentOperations[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja remover PERMANENTEMENTE o borderô nº ${deleted.OperationNumber}?`,
        "Confirmar EXCLUSÃO",
        this.DeleteAdvancePaymentOperation,
        i
      );
    },
    ConfirmDeleteAdvancePaymentOperationAdditionals: function (e, i) {
      e.preventDefault();
      this.$makeMsgBox(
        `Você tem certeza que deseja remover PERMANENTEMENTE está antecipação?`,
        "Confirmar EXCLUSÃO",
        this.DeleteAdvancePaymentOperationAdditionals,
        i
      );
    },
    DeleteAdvancePaymentOperation: function (i) {
      let deleted = this.advancePaymentOperations[i];
      this.$store
        .dispatch("DeleteAdvancePaymentOperation", { id: deleted.Id })
        .then(() => {
          this.$makeToast(
            `Borderô nº ${deleted.OperationNumber} foi removido da sua lista de borderôs`,
            "success",
            "Borderô"
          );
          this.ListAdvancePaymentOperation();
          this.$bvModal.hide("mFormAdvancePaymentOperation");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o borderô",
            error
          );
        });
    },
    DeleteAdvancePaymentOperationAdditionals: function (i) {
      this.infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals.splice(
        i,
        1
      );
    },
    OpenAdditional: function (add, i) {
      this.validatedAdditionalForm = false;
      this.loadingAddUpdateAdditional = false;
      this.ResetInfoAdditional();

      if (add) {
        // Add new
        this.isCreatingAdditional = true;
        this.modalTitleAdditional = "Nova antecipação";
      } else if (i != undefined) {
        // Edit
        this.isCreatingAdditional = false;
        this.pOpenedAdditionals = i;
        let pymt = this.infoAdvancePaymentOperation
          .AdvancePaymentOperationAdditionals[i];
        this.infoAdditional = JSON.parse(
          JSON.stringify({
            ...pymt,
          })
        );
        this.modalTitleAdditional = "Editar antecipação";
      }
      this.$bvModal.show("mFormAdditional");
    },
    ResetInfoAdditional: function () {
      this.pOpenedAdditionals = null;
      this.infoAdditional = {
        DueDate: null,
        Amount: null,
        Brand: {
          Code: null,
          Name: null,
        },
        Gateway: {
          Code: null,
          Name: null,
        },
      };
    },
    GetAdditional: function (id) {
      if (id != 0) {
        this.loadingModalAdditional = true;
        this.$store
          .dispatch("GetAdvancePaymentOperationAdditional", {
            id: id,
          })
          .then((response) => {
            this.infoAdditional = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar a antecipação",
              error
            );
          })
          .finally(() => {
            this.loadingModalAdditional = false;
          });
      }
    },
    SaveAdditional: function () {
      this.validatedAdditionalForm = true;
      this.$refs.AdditionalValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdateAdditional = true;
          for (var i = 0; i < this.gateways.length; i++) {
            if (this.gateways[i].Code == this.infoAdditional.Gateway.Code) {
              this.infoAdditional.Gateway = this.gateways[i];
            }
          }

          for (var i = 0; i < this.brands.length; i++) {
            if (this.brands[i].Code == this.infoAdditional.Brand.Code) {
              this.infoAdditional.Brand = this.brands[i];
            }
          }
          if (this.isCreatingAdditional) {
            // Add
            this.infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals.push(
              this.infoAdditional
            );
          } else {
            this.infoAdvancePaymentOperation.AdvancePaymentOperationAdditionals[
              this.pOpenedAdditionals
            ] = this.infoAdditional;
          }

          this.loadingAddUpdateAdditional = false;
          this.$bvModal.hide("mFormAdditional");
          this.pOpenedAdditionals = null;
          // else {
          //   // Update
          //   this.$store
          //     .dispatch(
          //       "UpdateAdvancePaymentOperationAdditional",
          //       this.infoAdditional
          //     )
          //     .then(() => {
          //       this.$makeToast(
          //         "Suas modificações foram salvas na base de dados",
          //         "success",
          //         "Borderô"
          //       );
          //       this.GetAdvancePaymentOperation(this.idAdvancePaymentOperation);
          //       this.$bvModal.hide("mFormAdditional");
          //     })
          //     .catch((error) => {
          //       this.$makeToast(
          //         undefined,
          //         "danger",
          //         "Erro ao atualizar a antecipação",
          //         error
          //       );
          //     })
          //     .finally(() => {
          //       this.loadingAddUpdateAdditional = false;
          //     });
          // }
        }
      });
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.nav-steps .breadcrumb-item:before {
  content: none;
}
.nav-steps .breadcrumb-item .active {
  text-decoration: underline;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/advancePaymentOperations.vue